import Vue from 'vue'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import ElementUI from 'element-ui';
import money from 'v-money';
import VueNumeric from 'vue-numeric'
import VueTabs from 'vue-nav-tabs'
import PSwitch from 'src/components/UIComponents/Switch.vue';
import API from '@/services/API';
import Armazenamento from '@/services/Armazenamento';
import html2pdf from '@/assets/html2pdf.js/dist/html2pdf.js'
import Swal from 'sweetalert2'
import dateUtil from 'element-ui/lib/utils/date'

Vue.use(ElementUI);
Vue.use(money);
Vue.use(VueNumeric);
Vue.use(VueFormWizard);
Vue.use(VueTabs)

export default {
  name: 'TempoRealCtrl',
  components: {
    PSwitch,
    money
  },
  data () {
    return {
      loader: false,
      loading: false,
      descricoes: null,
      resultados: {},
      entrada: {},
      dataEmissao: '',
      lotes: [{
        simulacao: 'Lote 1',
        quantidadeDiarias: '90',
        diariaAtual: '20',
        rendimentoPlanejado: '54,56',
        rendimentoAtual: '56,57'
      }],
      nomeImagemParceiro: null
    }
  },
  methods: {
    addSimulacao (item) {
      if (this.lotes.length > 4) {
        Swal('Aviso', 'São permitidos apenas 5 lotes nesta simulação', 'warning')
        return
      }
      this.lotes.push({
        simulacao: 'Lote Outro',
        quantidadeDiarias: '90',
        diariaAtual: '20',
        rendimentoPlanejado: '54,56',
        rendimentoAtual: '56,57'
      })
    },
    reload () {
      location.reload();
    },
    getInitialValues () {
      const descricoes = API.listar.descricoes()
      return Promise.all([descricoes])
    },
    getSimulation () {
      let that = this;
      let dataBase = this.$router.history.current.params.data;
      let lista = this.$router.history.current.params.lista;
      let tipo = this.$router.history.current.params.tipo;
      if (dataBase && lista && tipo) {
        let data = {
          dataBase: dataBase,
          tipo: tipo,
          simulacoes: lista
        }
        API.simulacao.calcular.relatorio.tempoReal(data)
          .then(response => {
            if (response.status === 200) {
              that.resultados = response.data.resultados;
              console.log(response.data);
              that.loading = false;
            } else {
              console.log(' #getSimulation (then -> else) Algo deu errado, recarregue a página');
            }
          })
          .catch(e => {
            console.error(' #getSimulation (catch) Algo deu errado, recarregue a página');
            console.error(e);
            this.$router.push({
              name: 'confinamento-basico-criar'
            }, window && window.location && window.location.reload());
          })
      }
    },
    exportReport () {
      var element = document.getElementById('report-all');
      html2pdf(element, {
        margin: 0.1,
        filename: 'relatorio-tempo-real.pdf',
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { dpi: 550, letterRendering: true },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
      })
    }
  },
  created () {
    this.loading = true
    this.dataEmissao = dateUtil.format(this.$router.history.current.params.data, 'dd/MM/yyyy');
    this.getInitialValues().then(([descricoes]) => {
      this.loading = false
      const assinatura = Armazenamento.assinatura.pegar()
      const valor = assinatura && assinatura.valor
      this.nomeImagemParceiro = valor && valor.cupom && valor.cupom.nomeImagemParceiro
      this.descricoes = descricoes;
      return this.getSimulation();
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Simulacoes/Relatorios/TempoReal/RelatorioCtrl.js